/* Luxe Life Accessories — ISO price format for JavaScript-rendered prices.

   Liquid prices go through snippets/lla-money.liquid. Prices the browser
   writes — variant switches, the cart drawer, predictive search, upsells,
   quick view, the set/bundle builders — are all produced by one function,
   themeVendor.themeCurrency.formatMoney, so wrapping that single function
   covers every client-rendered price in the theme.

   This file MUST load before theme.js: theme.js captures themeCurrency into
   its module closure at execution time, so the wrapper has to be installed on
   the shared object first. It is a plain synchronous script for that reason.

   The ISO code itself comes from Liquid (window.LLA_MONEY.iso), which is
   resolved per request from the active market's presentment currency. Nothing
   here converts, rounds or picks a currency: the cents handed to formatMoney
   are already in the shopper's currency, exactly as before. */
(function () {
  var CFG = window.LLA_MONEY || {};
  var ISO = CFG.iso || '';
  if (!ISO) return;

  var vendor = window.themeVendor && window.themeVendor.themeCurrency;
  if (!vendor || typeof vendor.formatMoney !== 'function') return;

  var original = vendor.formatMoney;

  /* Shopify's own format strings still decide grouping and decimal marks, so a
     euro market keeps "1.234,50" and a UK one "1,234.50". Only the trailing
     zero decimals are dropped, and only when they really are zeros: "395.50"
     keeps its 50. */
  function stripEmptyDecimals(value) {
    return String(value).replace(/([.,])00$/, '');
  }

  vendor.formatMoney = function (cents, format) {
    /* Format the number with the shop's pattern, then take just the digits and
       separators back out of it. Reusing the original keeps us correct for
       every currency Shopify supports without reimplementing its rules. */
    var formatted = original.call(this, cents, format);
    var number = String(formatted)
      .replace(/<[^>]*>/g, '')      // some money formats carry markup
      .replace(/[^\d.,\-]/g, '')    // drop symbols and any existing ISO code
      .trim();

    if (!number) return formatted;
    return stripEmptyDecimals(number) + ' ' + ISO;
  };
})();
